export default __webpack_public_path__ + "static/media/MaleHeadRight.37d68838.png";